// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@flip/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@flip/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { xCreateOrRequestQuote } from "@flip/App/Handlers/RequestQuote/CreateOrRequestQuote";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    CreateOrRequestQuote,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

// Event Data Layer sent when requesting a quote
export const _GaRequestAQuote: typeof CreateOrRequestQuote = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const data = props.apiResult;

    if (state.xGoogleAnalytics.rfqEvent) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const session = getSession(state);

        if (!data.quoteLineCollection || !(data.quoteLineCollection.length > 0)) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.rfqEventName,
            affiliation: getBillToState(state, session.billToId).value?.companyName,
            user: session.userName,
            page_path: getCurrentPage(state).type,
            ecommerce: {
                items: data.quoteLineCollection?.map((quoteLine, idx) => ({
                    item_id: quoteLine.erpNumber,
                    item_name: quoteLine.shortDescription,
                    affiliation: getBillToState(state, session.billToId).value?.companyName,
                })),
            },
        };
        
        dataLayer.push({ ecommerce: null });
        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, xCreateOrRequestQuote, _GaRequestAQuote);
